import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["base-button", { disabled: _ctx.isDisabled }]),
    disabled: _ctx.isDisabled
  }, [
    _createElementVNode("img", {
      src: _ctx.iconSrc,
      alt: _ctx.type,
      class: "icon-arrow"
    }, null, 8, _hoisted_2)
  ], 10, _hoisted_1))
}